/**
 * Created by staffanrantzow on 05/04/16.
 */

import axios from 'axios';
import SupplierLedgerEntity from './supplier-ledger-entity';
import SupplierLedgerTypeEntity from './supplier-ledger-type-entity';
import { APIResult } from '../http';
import Service from '../service/service';
import PendingRequestEntity from '../entities/pending-request-entity';
import { getVatById } from '../../views/invoice-tool/invoice-tool-helper';

class SupplierLedgerService extends Service {

  constructor () {
    super();
    this.types = null;
  }

  hydrateType (type) {
    var attr = type.attributes;

    return new SupplierLedgerTypeEntity(
      type.id,
      attr.active,
      attr.display_name,
      attr.display_order,
      attr.is_rot_rut,
      attr.specify_date,
      attr.tax_id
    );
  }

  hydrateTypeCollection (data) {
    var types = [];

    for (let type of data) {
      types.push(this.hydrateType(type));
    }

    return types;
  }

  hydrate (deduction, included = []) {
    var attr = deduction.attributes;
    let file = false;

    if (included.length && included[0].type === 'files') {
      file = included.find((inc) => parseInt(inc.attributes.fileable_id) === parseInt(deduction.id)) || false;
    }

    return new SupplierLedgerEntity(
      deduction.id,
      attr.amount,
      attr.arrived_date,
      attr.created_at,
      attr.expense_id,
      attr.invoice_id,
      attr.invoice_item_id,
      attr.payed_date,
      attr.status,
      attr.supplier_invoice_account,
      attr.supplier_invoice_nr,
      attr.supplier_invoice_ut,
      attr.supplier_ledger_type_id,
      attr.supplier_name,
      attr.tax_id,
      attr.tax_percent,
      attr.type_id,
      attr.user_id_authorization,
      attr.user_id_creator,
      file
    );
  }

  hydrateCollection (data, included) {
    var deductions = [];

    for (let deduction of data) {
      deductions.push(this.hydrate(deduction, included));
    }

    return deductions;
  }

  getById (id) {
    return axios.get('backend://supplier-ledgers/' + id + '?include=appendixfiles')
      .then((response) => this.hydrate(response.data.data, response.data.included));
  }

  get (userId, page, dateFilter, assigned) {
    var filter = this.getFilterDate(dateFilter, 'created_at');
    let pendingRequest = new PendingRequestEntity();

    let params = {
      'page[number]': page || 1,
      'page[size]': 25,
      'sort': '-created_at'
    };

    if (assigned) {
      params['filter[assigned]'] = 1;
    };

    pendingRequest.promise = axios.get('backend://users/' + userId + '/supplier-ledgers' + filter, {
      params,
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    })
      .then((response) => {
        var deductions = this.hydrateCollection(response.data.data);
        return new APIResult(deductions, response.data.meta);
      });

    return pendingRequest;
  }

  getForInvoice (invoiceId) {
    return axios
      .get(`backend://supplier-ledgers?filter[invoice_id]=${invoiceId}`)
      .then((response) => {
        const supplierLedgers = this.hydrateCollection(response.data.data);
        return new APIResult(supplierLedgers, response.data.meta);
      });
  }

  getTypes () {
    if (this.types) {
      return new Promise((resolve) => resolve(this.types));
    }
    return axios.get('backend://supplier-ledger-types?filter[active]=1')
      .then((response) => {
        this.types = this.hydrateTypeCollection(response.data.data);
        return this.types;
      });
  }

  extractParams (params, userId) {
    return {
      data: {
        attributes: {
          supplier_name: params.supplierName,
          tax_id: params.taxId,
          supplier_ledger_type_id: params.supplierLedgerTypeId,
          amount: 100*params.amount/(100+getVatById(params.taxId)),
          user_id: userId
        }
      }
    };
  }

  post (params, userId) {
    return axios.post('backend://supplier-ledgers', this.extractParams(params, userId))
      .then((response) => {
        return this.hydrate(response.data.data);
      });
  }

  postFile (params, supplierLedgerId) {
    const data = {
      data: {
        attributes: params
      }
    };
    const url = `backend://supplier-ledgers/${supplierLedgerId}/appendix-files`;
    return axios.post(url, data);
  }

}

export default new SupplierLedgerService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/supplier-ledgers/supplier-ledger-service.js
 **/